export default {
	title: 'Algorithm Model Configuration',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		modelConfig: 'Model Config',
		configHistory: 'Config History',
		addHealthCalculation: 'Add Health Calculation',
		start: 'Start',
		stop: 'Stop',
		refreshAlgorithmModel: 'Refresh Algorithm Model'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		setSuccess: 'Set successful',
		configSuccess: 'Config successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		noConfigHistory: 'No configuration history available',
		confirmAddHealthCalculation: 'Are you sure you want to add health calculation?',
		confirmRefreshAlgorithmModel: 'Are you sure you want to refresh the algorithm model? This operation will regenerate the model configuration.',
		confirmAdd: 'Confirm Add',
		confirmRefresh: 'Confirm Refresh',
		addHealthCalculationSuccess: 'Health calculation added successfully',
		refreshAlgorithmModelSuccess: 'Algorithm model refreshed successfully',
		getConfigHistoryError: 'Failed to get detail data'
	},
	form: {
		deviceName: 'Device',
		pointNo: 'Point Number',
		code: 'Model Group Code',
		name: 'Model Group Name',
		mmcodeList: 'Select Model',
                sys: 'Select Feature Values',
		placeholder: {
			deviceName: 'Please enter device name',
			pointNo: 'Please enter point number',
			code: 'Please enter model group code',
			name: 'Please enter model group name'
		}
	},
	table: {
		projNo: 'Project No',
		deviceName: 'Device',
		deviceNo: 'Device No',
		sensorName: 'Sensor',
		pointNo: 'Point Number',
		name: 'Name',
		mtype: 'Model Type',
		mmcode: 'Model Code',
                eigenKey: 'Feature Values',
		isEnable: 'Enabled'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm',
		modelConfigTitle: 'Model Configuration',
		configHistoryTitle: 'Configuration History'
	},
	gridLayout: 'Grid Layout',
	columns: {
		deviceName: 'Device Name',
		sensorName: 'Sensor Name',
		modelGroupName: 'Model Group Name',
		modelCode: 'Model Code',
		modelName: 'Model Name',
		isEnabled: 'Enabled',
		action: 'Action'
	},
	config: {
		selectDevice: 'Select Device',
		selectSensor: 'Select Sensor',
		selectAlgorithmGroup: 'Algorithm Model Group',
		paramType: 'Parameter Type',
		paramValue: 'Parameter Value',
		paramDesc: 'Parameter Description',
		configParam: 'Configuration Parameter',
		configTime: 'Configuration Time'
	},
	detailConfig: {
		title: 'Detailed Configuration',
		expandTitle: '{pointNo} - {sensorName} - Detailed Configuration'
	}
}
